
<div class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 sp-5">
        <tt-file-uploader ttLabelView="none" [(ttFiles)]="files" ttMultiple ttDropZone></tt-file-uploader>
        <tt-button [hidden]="files.length === 0" ttText="upload_files" ttIcon="fas fa-arrow-alt-from-bottom" (ttClick)="uploadFiles()" [ttLoading]="uploading"></tt-button>
    </tt-card>
</div>
